import axios from 'axios';
import {api} from '../../../modules/Inspection/constants/api';
import {errors as E} from 'common/constants/errors';
import {actions as A} from 'modules/Inspection/constants/actions';

export const getCities = () => dispatch => {
  dispatch({
    type: A.GET_CITIES,
  });

  return axios.post(api.GET_CITIES, {})
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      dispatch({
        type: A.GET_CITIES_SUCCESS,
        payload: transformCities(body.cities),
      });
    })
    .catch((err) => {
      dispatch({
        type: A.GET_CITIES_FAILURE,
        payload: err.message
      })
    });
};

const transformCities = cities => cities.map(city => {
  const {cityID, cityName} = city;
  return {label: cityName, value: cityID};
});


